import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './main/Routes';
import './index.css';
import { IntlProvider } from 'react-intl'; 
import * as serviceWorker from './serviceWorker';
import LocalizedStrings from './lang/LocalizedStrings';

// MSAL imports
import { EventType, EventMessage, AuthenticationResult, AuthError } from "@azure/msal-browser";
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from "./util/authUtil";

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
    console.log("accounts[0]", accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
        console.log("Login success: ", account);
    } else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      console.log("ACQUIRE_TOKEN_FAILURE:", event.error);
      if (event.error instanceof AuthError) {
        // If token acquire fails, at least logout for now...
        const account = msalInstance.getActiveAccount();
        const logoutRequest = {
          account
        }
        msalInstance.logoutRedirect(logoutRequest);
      }
    } else {
      console.log("MSAL event", event.eventType);
    }
});

/*
const locale = (navigator.languages && navigator.languages[0])
               || navigator.language
               || navigator.userLanguage
               || 'fi-FI';
*/

const locale = 'fi-FI';

// To prevent login popup to render App
// (https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/5091#issuecomment-1342312690)
if (window.location.hash !== ''){
  console.log("hash found" + window.location.hash);
}
else {
  ReactDOM.render(
    <IntlProvider locale={locale} messages={LocalizedStrings[locale]}>
      <Router>
        <React.StrictMode>
          <MsalProvider instance={msalInstance}>
            <Routes />
          </MsalProvider>
        </React.StrictMode>
      </Router>
    </IntlProvider>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
